import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { IProject } from 'src/typings/complexes';
import { IntegrationType } from 'src/typings/app';

interface IBitrixMainDataForm {
  integration: IntegrationType,
  register: any,
  project: IProject | null,
}

export const BitrixMainDataFormFields: React.FC<IBitrixMainDataForm> = ({ integration, register, project }) => {
  return (
    <>
      <Box mb={4} display="flex" alignItems="center">
        <Box width="260px" mr={3}>
          { `Domain of ${integration.toUpperCase()} account` }
        </Box>
        <Box width="260px">
          <TextField
            id="domain"
            size="small"
            variant="outlined"
            name="domain"
            inputRef={register}
            defaultValue={project && (project.domain)}
          />
        </Box>
      </Box>
      <Box mb={4} display="flex" alignItems="center">
        <Box width="260px" mr={3}>
          Webhook URL
        </Box>
        <Box width="260px">
          <TextField
            id="webhookUrl"
            size="small"
            variant="outlined"
            name="webhookUrl"
            inputRef={register}
            defaultValue={project && (project.webhookUrl)}
          />
        </Box>
      </Box>
    </>
  );
};
